/* global Swiper, attachEvent */
// *******************************************************************************
// 1.0 - Top Testimonial Slider
// *******************************************************************************

const topTestimonialSliderElements = document.querySelectorAll('[data-slider="testimonial-slider-top"]');
const bottomTestimonialSliderElements = document.querySelectorAll('[data-slider="testimonial-slider-bottom"]');

const topTestimonialSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 2,
};

topTestimonialSliderElements.forEach((el) => {
  const testimonialTumbnailSlider = new Swiper(el, topTestimonialSliderOptions);

  attachEvent('.testimonial-slider__top .swiper-slide', 'click', () => {
    testimonialTumbnailSlider.update();
  });
});

// *******************************************************************************
// 2.0 - Bottom Testimonial slider
// *******************************************************************************

const bottomTestimonialSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  autoHeight: true,
  fadeEffect: {
    crossFade: true,
  },
  allowTouchMove: false,
  noSwiping: false,
  thumbs: {
    swiper: false,
  },
};

bottomTestimonialSliderElements.forEach((el, i) => {
  bottomTestimonialSliderOptions.thumbs.swiper = topTestimonialSliderElements[i].swiper;

  // eslint-disable-next-line no-unused-vars
  const testimonialSlider = new Swiper(el, bottomTestimonialSliderOptions);
});
